// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/**\n* Colors\n*/\n.PageContent_wrapper__CQez4 {\n  background: white;\n  border-radius: 10px;\n  padding: 40px;\n  color: #262626;\n  position: relative; }\n  .PageContent_wrapper__CQez4.PageContent_initFullHeight__3Aoh0 {\n    min-height: calc(100vh - 176px); }\n  .PageContent_wrapper__CQez4.PageContent_noBackground__HBHV0 {\n    background: transparent; }\n  .PageContent_wrapper__CQez4.PageContent_noPadding__AfCTF {\n    padding: 0; }\n  .PageContent_wrapper__CQez4.PageContent_hasMargin__1NvBr {\n    margin: 24px; }\n", ""]);
// Exports
exports.locals = {
	"wrapper": "PageContent_wrapper__CQez4",
	"initFullHeight": "PageContent_initFullHeight__3Aoh0",
	"noBackground": "PageContent_noBackground__HBHV0",
	"noPadding": "PageContent_noPadding__AfCTF",
	"hasMargin": "PageContent_hasMargin__1NvBr"
};
module.exports = exports;
